import Vuex from 'vuex';
import { defaultBreakpoint } from '~/plugins/breakpoints';

const createStore = () => {
    return new Vuex.Store({
        state: () => {
            return {
                primaryColor: '#000',
                settings: {},
                scrollTop: null,
                scrollEnded: true,
                window: {
                    w: defaultBreakpoint,
                    h: null
                },
                modalState: {
                    active: false,
                    type: null,
                    id: null,
                    switchModalType: {
                        type: null,
                        id: null
                    }
                },
                metaInfo: {
                    title: null,
                    description: null,
                    structuredData: null,
                    social: null
                },
                YTApi: { ready: false, YT: null },
                copyToClipBoard: false
            };
        },
        getters: {
            windowWidth: state => {
                return state.window.w;
            }
        },
        mutations: {
            setPrimaryColor(state, primaryColor) {
                const hexaColor = new RegExp(
                    '^#[0-9a-fA-F]{6}|#[0-9a-fA-F]{3}$'
                );
                const test = hexaColor.test(primaryColor);
                if (test) {
                    state.primaryColor = primaryColor;
                }
            },
            setWindow(state, newWindow) {
                state.window = newWindow;
            },
            setModalState(storeState, { active, type, id }) {
                storeState.modalState.active =
                    active !== undefined
                        ? active
                        : storeState.modalState.active;
                storeState.modalState.type =
                    type !== undefined ? type : storeState.modalState.type;
                storeState.modalState.id = id ? id : null;
            },
            switchModalType(storeState, { type, id }) {
                storeState.modalState.switchModalType.type =
                    type !== undefined
                        ? type
                        : storeState.modalState.switchModalType.type;
                storeState.modalState.switchModalType.id = id ? id : null;
            },
            setMetaInfo(
                storeState,
                { title, description, structuredData, social }
            ) {
                storeState.metaInfo.title =
                    title && title !== '' ? title : storeState.metaInfo.title;
                storeState.metaInfo.description =
                    description && description !== ''
                        ? description
                        : storeState.metaInfo.description;
                storeState.metaInfo.structuredData =
                    structuredData && structuredData !== ''
                        ? JSON.parse(structuredData)
                        : storeState.metaInfo.structuredData;
                storeState.metaInfo.social =
                    social && social !== ''
                        ? social
                        : storeState.metaInfo.social;
            },
            YTApiReady(storeState, YT) {
                storeState.YTApi.ready = true;
                storeState.YTApi.YT = YT;
            },
            copyToClipBoard(storeState, copyState) {
                storeState.copyToClipBoard = copyState;
            }
        },
        actions: {}
    });
};

export default createStore;
